import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'

import { selectFunderProfileInfo } from 'store/selectors/profile'

import FunderPrograms from 'components/FunderPrograms'
import ProfileGrantFit from 'components/ProfileGrantFit'

import FunderProgramDescription from './components/FunderProgramDescription'
import FunderProgramInfo from './components/FunderProgramInfo'

const ProfilePrograms = ({ gotoTab, programIndex }) => {
  const { funderPrograms } = useSelector(selectFunderProfileInfo)

  const onProgramIndexChange = newIndex => {
    gotoTab(ProfilePrograms, [funderPrograms[newIndex].id])
  }

  const gotoGrantFit = () => {
    gotoTab(ProfileGrantFit, [funderPrograms[programIndex].id])
  }

  return (
    <Grid container columns={24} className="profile-programs">
      <Grid size={{ xs: 24, sm: 24, md: 5 }}>
        <FunderPrograms
          funderPrograms={funderPrograms}
          programIndex={programIndex}
          setProgramIndex={onProgramIndexChange}
        />
      </Grid>
      <Grid size={{ xs: 24, sm: 24, md: 9 }}>
        <FunderProgramDescription
          funderProgram={funderPrograms[programIndex]}
          gotoGrantFit={gotoGrantFit}
        />
      </Grid>
      <Grid size={{ xs: 24, sm: 24, md: 10 }}>
        <FunderProgramInfo funderProgram={funderPrograms[programIndex]} />
      </Grid>
    </Grid>
  )
}

ProfilePrograms.isEnabled = ({ isFunderDissolved, showPrograms }) =>
  !isFunderDissolved && showPrograms
ProfilePrograms.tabPath = 'programs'
ProfilePrograms.getTabName = t => t.funder.programs
ProfilePrograms.requiresProgramParam = true

export default ProfilePrograms
